<template>
  <div>
    <div id="editorjs"></div>
  </div>
</template>

<script>
/* eslint-disable no-unreachable */
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import Paragraph from "@editorjs/paragraph";
import List from "@editorjs/list";
import ImageTool from "@editorjs/image";
import AttachesTool from "@editorjs/attaches";

// eslint-disable-next-line no-unused-vars
function readAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onerror = reject;
    fr.onload = () => {
      resolve(fr.result);
    };
    fr.readAsDataURL(file);
  });
}

export default {
  name: "CardEditor",
  props: {
    card: Object,
    projectId: String,
    project: Object,
  },
  prev: {},
  data: () => ({
    editor: null,
    onChange: null,
  }),
  beforeDestroy() {
    self.editor?.destroy && self.editor.destroy();
  },
  mounted() {
    this.$nextTick(this.placeEditor);
  },
  methods: {
    save() {
      const self = this;
      self.editor.save().then((savedData) => {
        self.card.content = savedData;
      });
    },
    placeEditor() {
      const self = this;
      self.editor = new EditorJS({
        data: self.card.content,
        logLevel: "ERROR",
        autofocus: true,
        /**
         * This Tool will be used as default
         */
        initialBlock: "paragraph",
        // readOnly: true,
        tools: {
          header: {
            class: Header,
            shortcut: "CMD+SHIFT+H",
          },
          list: {
            class: List,
            inlineToolbar: ["link"],
          },
          paragraph: {
            class: Paragraph,
            config: {
              placeholder: ".",
            },
          },
          attaches: {
            class: AttachesTool,
            config: {
              uploader: {
                /**
                 * Upload file to the server and return an uploaded image data
                 * @param {File} file - file selected from the device or pasted by drag-n-drop
                 * @return {Promise.<{success, file: {url}}>}
                 */
                // eslint-disable-next-line no-unused-vars
                uploadByFile(file) {
                  let formData = new FormData();
                  formData.append("file", file);
                  return self.$api
                    .post("/binary/containers/" + self.projectId, formData, {
                      headers: {
                        "Content-Type": "multipart/form-data",
                      },
                    })
                    .then((res) => {
                      const result = res.data.result;
                      const containerId = result.containerId;
                      const fileId = result.id;
                      const ctx = {
                        success: 1,
                        file: {
                          url:
                            self.API_BASE_URL +
                            "/binary/containers/" +
                            containerId +
                            "/" +
                            fileId,
                          size: result.size,
                          extension: result.extension,
                          title: result.filename,
                        },
                      };
                      return ctx;
                    });
                },
              },
            },
          },
          image: {
            class: ImageTool,
            config: {
              /**
               * Custom uploader
               */
              uploader: {
                /**
                 * Upload file to the server and return an uploaded image data
                 * @param {File} file - file selected from the device or pasted by drag-n-drop
                 * @return {Promise.<{success, file: {url}}>}
                 */
                // eslint-disable-next-line no-unused-vars
                uploadByFile(file) {
                  let formData = new FormData();
                  formData.append("file", file);
                  return self.$api
                    .post("/binary/containers/" + self.projectId, formData, {
                      headers: {
                        "Content-Type": "multipart/form-data",
                      },
                    })
                    .then((res) => {
                      const containerId = res.data.result.containerId;
                      const fileId = res.data.result.id;
                      return {
                        success: 1,
                        file: {
                          url:
                            self.API_BASE_URL +
                            "/binary/containers/" +
                            containerId +
                            "/" +
                            fileId,
                        },
                      };
                    });
                  /**
                  return self.$api.get("/users").then(async () => {
                    const data = await readAsDataURL(file);
                    return {
                      success: 1,
                      file: {
                        url: data,
                        // any other image data you want to store, such as width, height, color, extension, etc
                      },
                    };
                  }); **/
                },
                // eslint-disable-next-line no-unused-vars
                uploadByUrl(blobUrl) {
                  return self.$api.get("/users").then(async () => {
                    return {
                      success: 1,
                      file: {
                        url: blobUrl,
                        // any other image data you want to store, such as width, height, color, extension, etc
                      },
                    };
                  });
                },
              },
            },
          },
        },
        onChange: function () {
          clearTimeout(self.onChange);
          self.onChange = setTimeout(self.save, 50);
        },
      });
    },
  },
};
</script>
<style>
.image-tool__image-picture {
  max-height: 350px;
}
</style>
